import React, { useContext } from 'react';
import styled from 'styled-components';
import { HELP_DESK_TICKET_BADGES } from '@ubeya/shared/constants/helpDesk';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 5.5px 8px;
  border-radius: 16px;
  font-size: 12px;
  line-height: 17px;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
  background: ${({ theme, $isPending }) => ($isPending ? theme.colors.yellowLight : theme.colors.primaryLight)};
  color: ${({ theme, $isPending }) => ($isPending ? theme.colors.orangeDark : theme.colors.primaryDark)};
`;

const TicketBadge = ({ ticket }) => {
  const { t } = useContext(ConfigContext);
  const isPending = ticket?.badge === HELP_DESK_TICKET_BADGES.PENDING;
  const isNew = ticket?.badge === HELP_DESK_TICKET_BADGES.NEW;
  const isResolved = !!ticket?.resolvedAt || !!ticket?.isResolved;

  if (isResolved || (!isNew && !isPending)) return null;

  return <Badge $isPending={isPending}>{isPending ? t('pending') : t('new')}</Badge>;
};

export default TicketBadge;
